export default __webpack_public_path__ + "media/images/logo_white-41b544c4525abf9ca810d98089b8e111.png";